<template>
  <header id="components-back-top-demo-custom" ref="header">
    <a-back-top>
      <div class="ant-back-top-inner">
        <a-icon type="arrow-up" />
        <div class="back-text">回到顶部</div>
      </div>
    </a-back-top>
    <div class="app-logos">
      <router-link class="logo" to="index">
        <img height="40px" src="@/assets/logo1.png">
      </router-link>
      <div class="line" />
      <router-link class="logo" to="index">
        <img height="40px" src="@/assets/logo2.png">
      </router-link>
    </div>
    <div class="header sk-pc-header">
      <a-menu v-model="current" mode="horizontal" :sub-menu-close-delay="20">
        <a-menu-item key="index" @click="linkTo('index')">
          首页
        </a-menu-item>
        <a-sub-menu key="solution" popup-class-name="sk-pc-submenu">
          <span
            slot="title"
            class="submenu-title-wrapper"
          >解决方案</span>
          <a-menu-item-group title="电商解决方案" class="htd-submenu-group">
            <a-menu-item key="micromall" @click="linkTo('micromall')">微商城</a-menu-item>
            <a-menu-item key="chainE" @click="linkTo('chainE')">连锁电商</a-menu-item>
            <a-menu-item key="community" @click="linkTo('community')">社群分销</a-menu-item>
            <a-menu-item key="B2B2C" @click="linkTo('B2B2C')">B2B2C</a-menu-item>
            <a-menu-item key="retail" @click="linkTo('retail')">零售电商</a-menu-item>
            <a-menu-item key="cloud-purchase" @click="linkTo('cloud-purchase')">云采购</a-menu-item>
            <a-menu-item key="live-broadcast" @click="linkTo('live-broadcast')">直播电商</a-menu-item>
          </a-menu-item-group>
          <a-menu-item-group title="智慧收银解决方案" class="htd-submenu-group">
            <a-menu-item key="cashier" @click="linkTo('cashier')">智能收银</a-menu-item>
            <a-menu-item key="payment" @click="linkTo('payment')">智能支付</a-menu-item>
          </a-menu-item-group>
          <a-menu-item-group title="会员营销解决方案" class="htd-submenu-group">
            <a-menu-item key="member" @click="linkTo('member')">会员CRM</a-menu-item>
            <a-menu-item key="popularize" @click="linkTo('popularize')">流量推广</a-menu-item>
          </a-menu-item-group>
          <a-menu-item-group title="企业定制解决方案" class="htd-submenu-group">
            <a-menu-item key="brandCustom" @click="linkTo('brandCustom')">品牌商城定制</a-menu-item>
            <a-menu-item key="distributeCustom" @click="linkTo('distributeCustom')">分销商城定制</a-menu-item>
            <a-menu-item key="shopCustom" @click="linkTo('shopCustom')">门店管理定制</a-menu-item>
            <a-menu-item key="O2OCustom" @click="linkTo('O2OCustom')">O2O定制</a-menu-item>
          </a-menu-item-group>
        </a-sub-menu>
        <a-sub-menu key="service" popup-class-name="sk-pc-submenu">
          <span
            slot="title"
            class="submenu-title-wrapper"
          >产业服务</span>
          <a-menu-item-group title="产业服务" class="htd-submenu-group">
            <a-menu-item key="finance" @click="linkTo('finance')">金融服务</a-menu-item>
            <a-menu-item key="supplychain" @click="linkTo('supplychain')">供应链服务</a-menu-item>
            <a-menu-item key="agent-operation" @click="linkTo('agent-operation')">代运营服务</a-menu-item>
          </a-menu-item-group>
        </a-sub-menu>
        <a-menu-item key="cooperation" @click="linkTo('cooperate')">
          渠道合作
        </a-menu-item>
        <a-menu-item key="partner" @click="linkTo('eco-partner')">
          生态伙伴
        </a-menu-item>
        <a-sub-menu key="aboutus" popup-class-name="sk-pc-submenu">
          <span
            slot="title"
            class="submenu-title-wrapper"
          >关于我们</span>
          <a-menu-item-group title="关于我们" class="htd-submenu-group">
            <a-menu-item key="aboutUs" @click="linkTo('aboutUs')">企业简介</a-menu-item>
            <a-menu-item key="dynamic" @click="linkTo('dynamic')">企业动态</a-menu-item>
          </a-menu-item-group>
        </a-sub-menu>
      </a-menu>
    </div>
    <div class="right-btn">
      <div>
        <a-button type="primary" @click="openModal(true)">
          免费试用
        </a-button>
      </div>
      <div style="margin-left: 10px;">
        <a-button type="danger" @click="openModal(false)">
          立即登录
        </a-button>
      </div>
    </div>
    <a-modal
      :title="null"
      :visible="visible"
      :footer="null"
      :centered="true"
      :get-container="() => $refs.header"
      :width="780"
      wrap-class-name="modal-content"
      @cancel="handleCancel"
    >
      <div>
        <div class="title">请选择您的角色</div>
        <div class="content">
          <div @click="handleOk('https://store.htd.cn/saas/#/login')">
            <img src="@/assets/images/common/register-icon-01.png" alt="">
            <div class="name">我是代理商</div>
          </div>
          <div @click="handleOk('https://store.htd.cn/saas/#/login')">
            <img src="@/assets/images/common/register-icon-02.png" alt="">
            <div class="name">我是品牌商</div>
          </div>
          <div v-if="isRegister" class="card-wapper">
            <div :class="isTop ? 'contain-Before' : ''" class="card0" @click="rotateCard(false)">
              <img src="@/assets/images/common/register-icon-03.png" alt="">
              <div class="name">我是零售门店</div>
            </div>
            <div class="card180" :class="isTop ? 'contain-After' : ''" @click="rotateCard(true)">
              <qrcode-vue value="https://mall.htd.cn/zc/#/beforePage?type=h5" class="qrcode" size="134" />
              <div class="name">我是零售门店</div>
            </div>
          </div>
          <div v-else @click="handleOk('https://hxg.htd.cn/login')">
            <img src="@/assets/images/common/register-icon-03.png" alt="">
            <div class="name">我是零售门店</div>
          </div>
        </div>
      </div>
    </a-modal>
  </header>
</template>
<script>
import { browseCount } from '@/apis/index'
import QrcodeVue from 'qrcode.vue'
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      current: ['home'],
      visible: false,
      selectIndex: null, // 代理商：1， 品牌商：2， 零售商：3
      isTop: false,
      isRegister: true
    }
  },
  watch: {
    '$route'(to, from) {
      this.initSelectPath()
    }
  },
  created: function() {
    this.initSelectPath()
  },
  methods: {
    // 是否需要显示二维码
    openModal(bool) {
      this.isRegister = bool
      this.visible = true
    },
    initSelectPath() {
      let path = this.$route.path
      if (path.startsWith('/')) {
        path = path.substr(1)
      }
      this.current = [path]
      browseCount()
    },
    linkTo(path) {
      if (!path.startsWith('/')) {
        path = '/' + path
      }
      this.$router.push({ path })
      browseCount()
    },
    handleOk(url) {
      window.open(url, '_blank')
      this.visible = false
    },
    handleCancel(e) {
      this.selectIndex = null
      this.visible = false
    },
    rotateCard(bool) {
      console.log('bool', bool)
      this.isTop = !bool
    }
  }
}
</script>
<style lang="less" scoped>
#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
}
#components-back-top-demo-custom .back-text {
  font-size: 12px;
  line-height: 20px;
}
#components-back-top-demo-custom .ant-back-top-inner {
  height: 60px;
  width: 60px;
  line-height: 40px;
  border-radius: 4px;
  background-color: #1088e9;
  color: #fff;
  text-align: center;
  font-size: 20px;
}
header {
  width: 100%;
  background: #fff;
  height: 60px;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  .app-logos{
    .line {
      display: inline-block;
      height: 40px;
      width: 1px;
      background-color: #E5E5E5;
      margin: 0 17px;
      vertical-align: middle;
    }
  }
  .header {
    display: flex;
    margin: 0 auto;
  }
  .right-btn {
      display: flex;
      .login-btn {
        cursor: pointer;
        margin-left: 12px;
        width: 104px;
        height: 32px;
        background: #ED7700;
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 32px;
      }
    }
  .modal-content {
    .title {
      font-size: 25px;
      font-weight: 500;
      color: #595961;
      line-height: 36px;
      text-align: center;
    }

    .card-wapper {
      position: relative;
      .card0 {
        position: absolute;
        backface-visibility: hidden;
        transition: 1.5s;
      }
      .card180 {
        position: absolute;
        backface-visibility: hidden;
        transform: rotateY(-180deg);
        transition: 1.5s;
        color: #000;
        width: 100%;
        height: 100%;
      }
      .qrcode {
        display: flex;
        height: 160px;
        align-items: center;
        visibility: hidden;
      }
      .contain-Before{
        transform: rotateY(180deg);
      }
      .contain-After{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transform: rotateY(0deg);
        .qrcode {
          visibility: visible;
          canvas {
            margin-top: 13px;
          }
        }
      }
    }
    .content {
      margin: 28px 0;
      display: flex;
      justify-content: space-evenly;
      text-align: center;
      &>div {
        width: 200px;
        height: 250px;
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        border: 2px solid #E9E9E9;
        .name {
          margin-top: 14px;
          font-size: 24px;
          font-weight: 600;
          color: #595961;
          line-height: 33px;
        }
      }
      &>div:hover {
        border: 2px solid #3986FF;
        background: rgba(57, 134, 255, 0.08);
      }
      &>div.active {
        border: 2px solid #3986FF;
        position: relative;
      }
      &>div.active::after{
        content: " ";
        position: absolute;
        bottom: -1px;
        right: -1px;
        height: 40px;
        width: 40px;
        background: url('~@/assets/images/common/register-selected.png') no-repeat;
        background-size: 100%;
      }
    }
    .btns {
      text-align: center;
      margin: 36px 0 12px 0;
      /deep/ .ant-btn {
        width: 220px;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
      }
    }
  }
}
</style>
